<template>
  <blog-form />
</template>

<script>
import BlogForm from "@/components/blogs/BlogForm.vue";

export default {
  name: "BlogCreate",
  components: { BlogForm },
};
</script>
